import React, { useCallback, useMemo } from 'react';

import { get } from 'lodash';
import { Box } from '@mui/material';
import SelectRule from '../utils/SelectRule';
import useListFilter from '../../hooks/useListFilter';

const RuleFilter = ({ source, label } : { source: string; label: string }) => {
  const { handelChangeFilter, filterValues } = useListFilter({ source });

  const values = useMemo(
    () => new Set(
      get(filterValues, source, []) as string[],
    ),
    [source, filterValues],
  );

  const onChange = useCallback((newValues: Set<string>) => {
    handelChangeFilter({ [source]: [...newValues] });
  }, [handelChangeFilter, source]);

  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <SelectRule
        onChange={onChange}
        values={values}
        label={`Filter ${label}`}
        field="id"
      />
    </Box>
  );
};

export default RuleFilter;
